import React from 'react';
import Activity from '@/components/shared/Activity';

interface ClientActivityProps {
  clientId?: string;
}

const ClientActivity: React.FC<ClientActivityProps> = ({ clientId }) => {
  return <Activity objectId={clientId || ''} title="Recent Activity" />;
};

export default ClientActivity;
